import Vue from 'vue';

Vue.filter('preferenceStorageProvider', value => {
  switch (value) {
    case 'LOCAL_STORAGE':
      return 'Local Storage (Legacy)';
    case 'DEXIE':
      return 'Dexie';
    default:
      return 'Unknown';
  }
});
